import { ContentAvatar } from './content/avatar';
import { ContentIntro } from './content/intro';
import { ContentArticleText } from './content/section';

/**
 * Model definition for portrait-box
 */
export interface PortraitBox {
  __contentType: 'portrait-box';
  id: string;
  name?: string;
  avatar?: ContentAvatar;
  article?: ContentArticleText;
  intro?: ContentIntro;
}

export function isPortraitBox(obj: { __contentType?: string }): obj is PortraitBox {
  return obj.__contentType === 'portrait-box';
}
